const MaterialDatePickerActivityXMl =
    `<?xml version="1.0" encoding="utf-8"?>
<androidx.constraintlayout.widget.ConstraintLayout xmlns:android="http://schemas.android.com/apk/res/android"
    xmlns:app="http://schemas.android.com/apk/res-auto"
    xmlns:tools="http://schemas.android.com/tools"
    android:layout_width="match_parent"
    android:layout_height="match_parent"
    tools:context=".MainActivity">

    <LinearLayout
        android:layout_width="match_parent"
        android:layout_height="wrap_content"
        android:orientation="vertical"
        app:layout_constraintBottom_toBottomOf="parent"
        app:layout_constraintEnd_toEndOf="parent"
        app:layout_constraintStart_toStartOf="parent"
        app:layout_constraintTop_toTopOf="parent">

        <TextView
            android:id="@+id/dateTxt"
            android:layout_width="match_parent"
            android:layout_height="wrap_content"
            android:textAlignment="center"
            android:textSize="16sp" />

        <Button
            android:id="@+id/materialDatePickerBtn"
            android:layout_width="match_parent"
            android:layout_height="wrap_content"
            android:layout_margin="8dp"
            android:text="Material date picker" />
    </LinearLayout>
</androidx.constraintlayout.widget.ConstraintLayout>`

const MaterialDatePickerActivityKT =
    `package com.example

import android.os.Bundle
import android.widget.Button
import android.widget.TextView
import androidx.appcompat.app.AppCompatActivity
import com.google.android.material.datepicker.MaterialDatePicker
import java.text.SimpleDateFormat
import java.util.*


class MainActivity : AppCompatActivity() {

    override fun onCreate(savedInstanceState: Bundle?) {
        super.onCreate(savedInstanceState)
        setContentView(R.layout.activity_main)

        // todo: Material date picker code
        val materialDatePicker =
            MaterialDatePicker.Builder.datePicker()
                .setTitleText("Select Date")
                //  .setSelection(MaterialDatePicker.todayInUtcMilliseconds())
                .build()
        materialDatePicker.addOnPositiveButtonClickListener {
            val myFormat = "dd-MMM-yyyy" // mention the format you need
            val sdf = SimpleDateFormat(myFormat, Locale.US)
            findViewById<TextView>(R.id.dateTxt).text = sdf.format(materialDatePicker.selection)
        }
        findViewById<Button>(R.id.materialDatePickerBtn).setOnClickListener {
            materialDatePicker.show(supportFragmentManager,"MATERIAL_DATE_PICKER")
        }
        // todo: Material date picker code
    }

}`

module.exports = {
    MaterialDatePickerActivityXMl: MaterialDatePickerActivityXMl,
    MaterialDatePickerActivityKT: MaterialDatePickerActivityKT
};